import { ExclusiveLensStatus, LensCreatorPayoutEligibility, type MyLensesLens } from "../../gql-generated/types";

interface ExclusiveLensFlags {
    isExclusiveLens: boolean;
    isExclusiveLensPending: boolean;
    hasExclusiveLensProgram: boolean;
}

export const getExclusiveLensFlags = (
    exclusiveLensStatus: ExclusiveLensStatus,
    isExclusiveLensChecked?: boolean,
): ExclusiveLensFlags => {
    const isExclusiveLens = exclusiveLensStatus === ExclusiveLensStatus.ExclusiveLensStatusExclusive;
    const isExclusiveLensPending = exclusiveLensStatus === ExclusiveLensStatus.ExclusiveLensStatusEligible;
    const hasExclusiveLensProgram = isExclusiveLens || isExclusiveLensPending || (isExclusiveLensChecked ?? false);

    return {
        isExclusiveLens,
        isExclusiveLensPending,
        hasExclusiveLensProgram,
    };
};

export const calculateOwnerMismatch = (
    lensForUpdate: Pick<MyLensesLens, "distributionsList" | "lensCreatorPayoutEligibility"> | undefined,
    currentUserId: string | undefined,
): boolean => {
    return !!(
        lensForUpdate &&
        !lensForUpdate.distributionsList.some((distribution) => distribution.destinationId === currentUserId) &&
        lensForUpdate.lensCreatorPayoutEligibility === LensCreatorPayoutEligibility.LensCreatorPayoutEligibilityUnset
    );
};
